import { Directive } from '@angular/core';

@Directive({
  selector: 'tab2',
  standalone: false,
})
export class Tab2Directive {}
